import Vue from "vue";
import moment from "moment";
export default class DateService {
  constructor(vue) {}

  addDays(dt, days) {
    try {
      var d = new Date(dt);

      return moment(d)
        .add("d", days)
        .toDate();
    } catch {
      return null;
    }
  }
  subtractDays(dt, days) {
    var d = new Date(dt);

    return moment(d)
      .subtract("d", days)
      .toDate();
  }

  thisDayAt(d, time) {
    d = new Date(d);
    d.setHours(time.split(":")[0]);
    d.setMinutes(time.split(":")[1]);
    d.setSeconds(0);
    d.setMilliseconds(0);
    return d;
  }

  //format date for url
  formatDateForUrl(d) {
    return d.getMonth() + 1 + "/" + d.getDate() + "/" + d.getFullYear();
  }

  //moves the time from d1 to d2 to the same time as d1
  moveTimeToDate(d2, d1) {
    d1 = new Date(d1);
    d2 = new Date(d2);
    d2.setHours(d1.getHours());
    d2.setMinutes(d1.getMinutes());
    d2.setSeconds(d1.getSeconds());
    d2.setMilliseconds(d1.getMilliseconds());
    return d2;
  }

  getDuration(d1, d2) {
    return moment
      .duration(
        moment(d2, "YYYY/MM/DD HH:mm").diff(moment(d1, "YYYY/MM/DD HH:mm"))
      )
      .asHours();
  }
  // Get the previous sunday of a given month
  getPreviousSunday(d) {
    var t = new Date(d);
    t.setDate(t.getDate() - t.getDay());
    return t;
  }
}
